/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const today = new Date();
const yyyy = today.getFullYear();
const mm = today.getMonth() + 1; // Months start at 0!
const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
const currDate = `${mm}/${dd}/${yyyy}`;

const initialState = {
  selected_type: Constants.MANUFACTURER_REBATE_ID,
  // selectedCreatePlanType: 'ST',
  selected_search_type: Constants.Name,
  planType: [],
  errorMessagesInRedux: [],
  searchContractState: {
    planType: '',
    rebateProgramCode: '',
    popupRebateProgramCode: '',
    createPlanType: 'ST',
    createRebateProgramCode: '-1',
    searchContractDate: currDate,
    selectedContractType: '',
    selectedRowData: '',
    selectedContractId: '',
    selectedMfgName: '',
    contractType: '',
    getQuarter: '',
    errorInvalidQuarter: false,
    errorQuarterRequired: false,
    errorInvalidDate: false,
    errorDateRequired: false,
    errorRebateProg: false,
    selectedCreateMfgRowData: {},
    enableSave: false,
  },
  errorsearchContract: [],
  errorOthersearchContract: [],
  maintainContractState: {
    rebateProgramCd: '',
    mfgId: '',
    mfgName: '',
    shortDescr: '',
    contractSeqNum: '',
    contractName: '',
    contractStartDate: null,
    contractEndDate: null,
    errorContractName: false,
    errorStartDate: false,
    errorEndDate: false,
    errorInvalidStartDate: false,
    errorInvalidEndDate: false,
    corrLinkId: null,
    showSaveButton: 'No',
    disableDrugFamilyTab: true,
    disableCoverageTab: false,
    disableCalTab: false,
    calTab: {
      cmsNdcInclInd: false,
      nonCmsNdcInclInd: false,
      contractCalcMethodCd: '-1',
      calcNonInnovPct: '',
      calcInnovSinglePct: '',
    },
    detailTab: {
      detailInvoices: '-1',
      disputeSpecialists: '-1',
      letterSender: '-1',
      earliestQuarter: '',
      errorInvalidQuarter: false,
      sendToCommercialMfgInd: false,
      useDefRpcInd: false,
      writeOffDate: null,
      writeOffDatePop: null,
      errorInvalidWirteOffDate: false,
      errorInvalidWirteOffDatePop: false,
    },
    manufacturerTab: {
      paperFinalQtr: null,
      printImageFinalQtr: null,
      cmsElectFinalQtr: null,
      ncpdpSummaryFinalQtr: null,
      ncpdpClaimOwnFinalQtr: null,
      ncpdpClaimMbFinalQtr: null,
      useDefMfgInd: 0,
      useDefRpcInd: 0,
      paperInd: 0,
      printImageInd: 0,
      cmsElectInd: 0,
      ncpdpSummaryInd: 0,
      ncpdpClaimOwnInd: 0,
      ncpdpClaimMbInd: 0,
      sendToCommercialMfgInd: 0,
      contractValidInd: 0,
      pricingTimingCd: '-1',
      enrollmentTimingCd: '-1',
      detailLevelOnInvoiceCd: null,
      collectionMediumCd: '-1',
      contractDefDispSpecialist: null,
      letterSenderUserId: null,
      invContactSeqNum: null,
      dispContactSeqNum: null,
      writeOffDt: null,
    },
    invoiceContact: {
      manufacturerID: '',
      manufacturerName: '',
      contactTypeCode: '',
      description: '',
      contactName: '',
      corpName: '',
      addrLine1: '',
      addrLine2: '',
      addrLine3: '',
      city: '',
      stateCd: '',
      zip: '',
      zip4: '',
      phoneNum: '',
      phoneExtension: '',
      faxNum: '',
      email: '',
    },
    disputeContract: {
      manufacturerID: '',
      manufacturerName: '',
      contactTypeCode: '',
      description: '',
      contactName: '',
      corpName: '',
      addrLine1: '',
      addrLine2: '',
      addrLine3: '',
      city: '',
      stateCd: '',
      zip: '',
      zip4: '',
      phoneNum: '',
      phoneExtension: '',
      faxNum: '',
      email: '',
    },
    errordisputeContract: {
      manufacturerID: '',
      manufacturerName: '',
      contactTypeCode: '',
      description: '',
      invalidPhoneNum: false,
      invalidEmail: false,
    },
    getAllOtherContract: [],
    listOfOtherContact: [],
    otherContract: {
      contactTypeCd: 'CTR1',
      contactName: '',
      corpName: '',
      addrLine1: '',
      addrLine2: '',
      addrLine3: '',
      city: '',
      stateCd: '',
      zip: '',
      zip4: '',
      phoneNum: '',
      phoneExtension: '',
      faxNum: '',
      email: '',
      corrLinkId: null,
    },
    errorOtherContract: {
      contactName: false,
      corpName: false,
      addrLine1: false,
      city: false,
      stateCd: false,
      zip: false,
      phoneNum: false,
      email: false,
      invalidPhoneNum: false,
      invalidEmail: false,
    },
    drugFamily: {
      drugFamilyQtr: '',
      errorInvalidQuarter: false,
      selectedDrugFamilyAddRow: {},
    },
  },
  errorMaintainContract: [],
  tabValue: 'one',
  references: [],
  prices: [],
  enrollments: [],
  collections: [],
  getCoverageTable: [],
  getDrugFamilyTable: [],
  getDisputeSpecialists: [],
  getLetterSender: [],
  getContactType: [],
  getSearchContractDetails: [],
  getAllContractData: {},
  getAllCopyContractData: [],
  defaultMfgDataDataForContract: {},
  getDefaultRpcData: {},
  getMfgByPlanAndRpc: [],
  getAllDrugFamiliesByMfgId: [],
  getValidatedContract: '',
  getWriteOffDate: '',
  createUpdateContract: '',
  getUndoWriteOffDate: '',
  getShowContractInfo: [],
  initialResponse: false,
  onClickCell: false,
  newContractSeqNum: null,
  selectInvoiceContactList: [],
  selectDisputeContactList: [],
  getDisputeContractContactDetails: {},
  getInvoiceContractContactDetails: {},
  deleteDrugFamily: [],
  deleteCoverageGap: [],
  getOnLoadCoverageData: [],
  fetchAllCommonContractDFDropdowns: [],
  marketBasketDrugFamily: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_CONTRACT_STATE:
      return { ...state, searchContractState: action.payload };
    case actionTypes.ERROR_SEARCH_CONTRACT:
      return { ...state, errorsearchContract: action.payload };
    case actionTypes.ERROR_OTHER_SEARCH_CONTRACT:
      return { ...state, errorOthersearchContract: action.payload };
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.GET_POPUP_REBATE_PROGRAMS:
      return { ...state, popupRebateProgramCode: action.payload };
    case actionTypes.GET_COMMON_CONTRACT_DROPDOWN:
      return {
        ...state,
        fetchAllCommonContractDFDropdowns: action.payload,
      };
    case actionTypes.SELECTION_TYPE_OPTIONS:
      return { ...state, selection_list: action.payload };
    case actionTypes.SELECTED_TYPE:
      return { ...state, selected_type: action.payload };
    case actionTypes.SELECTED_CREATE_PLAN_TYPE:
      return { ...state, selectedCreatePlanType: action.payload };
    case actionTypes.SELECTED_SEARCH_TYPE:
      return { ...state, selected_search_type: action.payload };
    case actionTypes.ADD_COVERAGE_DATE:
      return { ...state, add_coverage_date: action.payload };
    case actionTypes.GET_REFERENCES:
      return { ...state, marketBasketDrugFamily: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA:
      var updatedArray = [];
      if (action.planType) {
        var localAr = action.planType;
        if (localAr?.PLAN_TYPE_CD?.length > 0) {
          const planArray = localAr?.PLAN_TYPE_CD;
          planArray.forEach((element) => {
            if (element?.codeValueID?.codeValue == 'FD') {
              const indexOf = _.findIndex(planArray, element);
              if (!_.isNull(indexOf) && indexOf >= 0) {
                updatedArray = arrayMove(localAr?.PLAN_TYPE_CD, indexOf, 0);
              }
              localAr.PLAN_TYPE_CD = updatedArray;
            }
          });
        }
      }
      return {
        ...state,
        planType: localAr,
      };
    case actionTypes.GET_CONTRACT_TAB_VALUE:
      return { ...state, tabValue: action.payload };
    case actionTypes.GET_COVERAGE_TABLE:
      let arr = [];
      const getCoveragetbl = [...state.getCoverageTable];
      if (action.payload.functionality === 'Add') {
        if (action.payload.index !== '' && action.payload.colId === '') {
          const rowData =
            getCoveragetbl &&
            getCoveragetbl.map((item, index) => {
              arr.push(item);
              if (index === action.payload.index) {
                arr.push(action.payload.newField);
              }
            });
        } else if (action.payload.index === '' && action.payload.colId === '') {
          getCoveragetbl.push(action.payload.newField);
          arr = [...getCoveragetbl];
        } else if (action.payload.index !== '' && action.payload.colId !== '') {
          const getCoveragetbl = [...state.getCoverageTable];
          arr = [];
          const rowData =
            getCoveragetbl &&
            getCoveragetbl.map((item, index) => {
              arr.push(item);
            });
        } else {
          arr = [...action.payload.newField];
        }
        return {
          ...state,
          getCoverageTable: arr,
        };
      }
      if (action.payload.functionality === 'onLoad') {
        const arr = [...action.payload.newField];
        arr &&
          arr.forEach((item, index) => {
            item.startDate = item.startDate
              ? moment(
                  new Date(
                    item.startDate
                    // new Date(item.startDate).toLocaleString("en-US", {
                    //   timeZone: process.env.REACT_APP_TIMEZONE,
                    // })
                  )
                ).format('MM/DD/YYYY')
              : null;
            item.endDateErr = false;
            item.startDateErr = false;
            item.alreadyAdded = true;
            item.indexKey = index;
            item.endDate = item.endDate
              ? moment(
                  new Date(
                    item.endDate
                    // new Date(item.endDate).toLocaleString("en-US", {
                    //   timeZone: process.env.REACT_APP_TIMEZONE,
                    // })
                  )
                ).format('MM/DD/YYYY')
              : null;
          });
        return {
          ...state,
          getCoverageTable: arr,
        };
      }
      const result = getCoveragetbl.filter((item, index) => {
        if (index !== action.payload.index) return item;
      });
      return {
        ...state,
        getCoverageTable: result,
      };
    case actionTypes.MAITAIN_CONTRACT_STATE:
      return { ...state, maintainContractState: action.payload };
    case actionTypes.GET_DISPUTE_SPECIALIST:
      return { ...state, getDisputeSpecialists: action.payload };
    case actionTypes.GET_LETTER_SENDER:
      return { ...state, getLetterSender: action.payload };
    case actionTypes.GET_MARKET_BASKET_NAME:
      return { ...state, marketBasketName: action.payload };
    case actionTypes.GET_CONTRACT_CONTACT_TYPE:
      return { ...state, getContactType: action.payload };
    case actionTypes.GET_CONTRACT_SEARCH_DATA:
      return { ...state, getSearchContractDetails: action.payload };
    case actionTypes.GET_ALL_CONTRACTS_DETAILS:
      return { ...state, getAllContractData: action.payload };
    case actionTypes.GET_QUARTER_FOR_CONTRACT:
      const searchContractState = { ...state.searchContractState };
      return {
        ...state,
        searchContractState: {
          ...searchContractState,
          getQuarter: action.payload,
        },
      };
    case actionTypes.GET_CONTRACT_SEQUENCE_NUM:
      const maintainContractState = { ...state.maintainContractState };
      return {
        ...state,
        maintainContractState: {
          ...maintainContractState,
          contractSeqNum: action.payload?.contractSeqNum,
        },
      };
    case actionTypes.GET_CONTRACT_FROM_COPY_CONTRACT:
      return { ...state, getAllCopyContractData: action.payload };
    case actionTypes.GET_DEFAULT_MFG_DATA:
      return {
        ...state,
        defaultMfgDataDataForContract: action.defaultMfgDataDataForContract,
      };
    case actionTypes.GET_DEFAULT_RPC_DATA:
      return { ...state, getDefaultRpcData: action.payload };
    case actionTypes.ERROR_MAINTAIN_CONTRACT:
      return { ...state, errorMaintainContract: action.payload };
    case actionTypes.GET_MFG_BY_PLAN_REBATE_PROG:
      return { ...state, getMfgByPlanAndRpc: action.payload };
    case actionTypes.GET_DRUG_FAMILY_BY_MFG_ID:
      return { ...state, getAllDrugFamiliesByMfgId: action.payload };
    case actionTypes.GET_DRUG_FAMILY_TABLE:
      let array = [];
      const getDrugtbl = [...state.getDrugFamilyTable];
      if (action.payload.functionality === 'Add') {
        if (action.payload.index !== '' && action.payload.colId === '') {
          const rowData =
            getDrugtbl &&
            getDrugtbl.map((item, index) => {
              array.push(item);
              if (index === action.payload.index) {
                array.push(action.payload.newField);
              }
            });
        } else if (action.payload.index === '' && action.payload.colId === '') {
          getDrugtbl.push(action.payload.newField);
          array = [...getDrugtbl];
        } else if (action.payload.index !== '' && action.payload.colId !== '') {
          const getDrugtbl = [...state.getDrugFamilyTable];
          array = [];
          const rowData =
            getDrugtbl &&
            getDrugtbl.map((item, index) => {
              array.push(item);
            });
        } else {
          array = [...action.payload.newField];
        }
        return {
          ...state,
          getDrugFamilyTable: array,
        };
      }
      if (action.payload.functionality === 'onLoad') {
        const array2 = [...action.payload.newField];
        array2 &&
          array2.forEach((item, index) => {
            item.alreadyAdded = item?.alreadyAdded || false;
          });
        return {
          ...state,
          getDrugFamilyTable: array2,
        };
      }
      if (action?.payload.length == 0) {
        return {
          ...state,
          getDrugFamilyTable: [],
        };
      } else {
        const result = getDrugtbl.filter((item, index) => {
          if (index !== action.payload.index) return item;
        });
        return {
          ...state,
          getDrugFamilyTable: result,
        };
      }
    case actionTypes.VALIDATE_CONTRACT:
      return { ...state, getValidatedContract: action.getValidatedContract };
    case actionTypes.GET_WRITE_OFF_DATE_CONTRACT:
      return { ...state, getWriteOffDate: action.getWriteOffDate };
    case actionTypes.CREATE_UPDATE_CONTRACT:
      return { ...state, createUpdateContract: action.payload };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_CONTRACT:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };

    case actionTypes.GET_UNDO_WRITE_OFF_DATE_CONTRACT:
      return { ...state, getUndoWriteOffDate: action.getUndoWriteOffDate };
    case actionTypes.CLEAR_REDUX_CTRCT:
      return [];
    case actionTypes.GET_CONTRACT_INFO:
      if (
        action.getShowContractInfo &&
        action.getShowContractInfo.error !== 'API Failed'
      ) {
        action.getShowContractInfo &&
          action.getShowContractInfo.forEach((item, i) => {
            item.index = i;
            item.startDt = item.startDt
              ? moment(
                  new Date(
                    new Date(item.startDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
            item.endDt = item.endDt
              ? moment(
                  new Date(
                    new Date(item.endDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
          });
      }
      return { ...state, getShowContractInfo: action.getShowContractInfo };
    case actionTypes.INITIAL_RESPONSE:
      return { ...state, initialResponse: action.payload };
    case actionTypes.CELL_CLICK:
      return { ...state, onClickCell: action.payload };
    case actionTypes.GET_SELECT_CONTRACT_FOR_INVOICE_CONTACT:
      return {
        ...state,
        selectInvoiceContactList: action.selectInvoiceContactList,
      };
    case actionTypes.SELECTED_ROW:
      return { ...state, selectedRowDetails: action.payload };
    case actionTypes.GET_SELECT_CONTRACT_FOR_DISPUTE_CONTACT:
      return {
        ...state,
        selectDisputeContactList: action.selectDisputeContactList,
      };

    case actionTypes.GET_NEW_CONTRACT_SEQUENCE_NUM:
      return {
        ...state,
        newContractSeqNum: action?.newContractSeqNum?.contractSeqNum,
      };
    case actionTypes.GET_INV_CONTRACT_CONTACT_DETAILS:
      // if (action.payload?.type == 'Dispute') {
      //   return { ...state, getDisputeContractContactDetails: action.payload };
      if (action.payload?.type == 'Invoice') {
        return { ...state, getInvoiceContractContactDetails: action.payload };
      }
      return { ...state, getInvoiceContractContactDetails: action.payload };

    case actionTypes.GET_DISPUTE_CONTRACT_CONTACT_DETAILS:
      if (action.payload?.type === 'Dispute') {
        return { ...state, getDisputeContractContactDetails: action.payload };
      }
      return { ...state, getDisputeContractContactDetails: action.payload };

    case actionTypes.GET_DELETE_DRUG_FAMILY_TABLE:
      if (action.payload.length == 0) {
        return { ...state, deleteDrugFamily: [] };
      }

      const getDeleteDrugtbl = [...state.deleteDrugFamily];
      getDeleteDrugtbl.push(action.payload);
      return { ...state, deleteDrugFamily: getDeleteDrugtbl };

    case actionTypes.GET_DELETE_COVERAGE_GAP:
      if (action.payload.length == 0) {
        return { ...state, deleteCoverageGap: [] };
      }

      const getDeleteCoverage = [...state.deleteCoverageGap];
      getDeleteCoverage.push(action.payload);
      return { ...state, deleteCoverageGap: getDeleteCoverage };

    case actionTypes.GET_LOAD_COVERAGE_TABLE:
      if (action.payload.length == 0) {
        return { ...state, getOnLoadCoverageData: [] };
      }

      const getLoadedCoverageTbl = action.payload;
      getLoadedCoverageTbl &&
        getLoadedCoverageTbl.map((item, index) => {
          item.alreadyAdded = true;
          item.indexKey = index;
        });
      return { ...state, getOnLoadCoverageData: getLoadedCoverageTbl };
    
    case actionTypes.CONTRACT_TAB_DATA:
  
      return {
              ...state,
              maintainContractState: {
                ...state.maintainContractState,
                calTab: {
                  ...state.maintainContractState.calTab,
                  ...action.payload
                }
              }
            };

      
    default:
      return state;
  }
};

export default reducer;
